import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

// 생성
export const createCase = async (param) => {
  const response = await axios.post(`${baseUrl}/salus-case-work/case`, param)
  return response.data
}

// 목록
export const getCaseList = async (salusUserId) => {
  const response = await axios.get(`${baseUrl}/salus-case-work/case/list`, {
    params: { salusUserId },
  })
  return response.data
}
// 상세
export const getCaseDetail = async (caseWorkId) => {
  const response = await axios.get(
    `${baseUrl}/salus-case-work/case/${caseWorkId}`,
  )
  return response.data
}

export const getCaseDetailByStep = async (caseWorkId, step) => {
  const response = await axios.get(
    `${baseUrl}/salus-case-work/case/${caseWorkId}/${step}`,
  )
  return response.data
}

export const updateCase = async (caseWorkId, payload) => {
  // {
  //   "caseWorkId": 0,
  //   "salusUserId": 0,
  //   "title": "string",
  //   "totalSteps": 0,
  //   "processList": [
  //     {
  //       "processId": 0,
  //       "title": "string",
  //       "step": 0
  //     }
  //   ]
  // }
  const response = await axios.put(
    `${baseUrl}/salus-case-work/${caseWorkId}`,
    payload,
  )
  return response.data
}

//삭제
export const deleteCase = async (caseWorkId) => {
  const response = await axios.delete(
    `${baseUrl}/salus-case-work/case/${caseWorkId}`,
  )
  return response.data
}
// --------------------------------

// 이슈생성
export const createCaseIssue = async (payload) => {
  const response = await axios.post(`${baseUrl}/salus-case-work/issue`, payload)
  return response.data
}
// 이슈 생성 시 상태 목록 조회
export const getCaseIssueStatusList = async (caseWorkId) => {
  const response = await axios.get(
    `${baseUrl}/salus-case-work/issue/creation-template/${caseWorkId}`,
  )
  return response.data
}

// 이슈 상세
export const getCaseIssueDetail = async (issueId) => {
  const response = await axios.get(
    `${baseUrl}/salus-case-work/issue/${issueId}`,
  )
  return response.data
}

// 이슈 수정
export const updateCaseIssue = async (payload) => {
  // {
  //   "issueId": 0,
  //   "title": "string",
  //   "slaDateTime": "2026-01-21T02:32:26.487Z",
  //   "caseWorkProcessId": 0,
  //   "memo": "string"
  // }
  const response = await axios.put(`${baseUrl}/salus-case-work/issue`, payload)
  return response.data
}

// 이슈 삭제ㅐ
export const deleteCaseIssue = async (issueId) => {
  const response = await axios.delete(
    `${baseUrl}/salus-case-work/issue/${issueId}`,
  )
  return response.data
}
